import { useState, useEffect } from "react";

/**
 * Custom hook that can be used to check if an element is displayed on the screen after scrolling
 * @function useVisibleOnScroll
 * @param ref
 * @returns {boolean}
 */
export default function useVisibleOnScroll(
  ref: React.MutableRefObject<any>,
  scrollElement: Element
) {
  const [isVisibleOnScroll, setIsVisibleOnScroll] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      setIsVisibleOnScroll(entry.isIntersecting);
    });

    const scrollHandler = () => {
      if (ref.current) {
        observer.observe(ref.current);
      }
    };

    if (scrollElement) scrollElement.addEventListener("scroll", scrollHandler);

    return () => {
      if (scrollElement)
        scrollElement.removeEventListener("scroll", scrollHandler);
      observer.disconnect();
    };
  }, [ref]);

  return isVisibleOnScroll;
}
